export const DEFAULT_TRANSLATIONS = {
  basket: 'basket',
  copy: 'Copy',
  copyLink: 'Copy Link',
  emptyBag: 'Empty bag',
  emptyBagMessage: 'Looking pretty empty in your bag',
  goToBasket: 'Go to basket',
  linkCopied: 'Link copied!',
  qty: 'qty',
  shareWithBrandPartner: 'Share basket with brand partner',
  shareYourBasket: 'share your basket',
  superdeal: 'superdeal',
};

export type Translations = Partial<typeof DEFAULT_TRANSLATIONS>;
export type TranslationKey = keyof typeof DEFAULT_TRANSLATIONS;
export type TranslationKeys = {
  [key in TranslationKey]: key;
};

/**
 * Use this object to access the particular translaion ID / key.
 */
export const translationKeys = Object.fromEntries(
  Object.keys(DEFAULT_TRANSLATIONS).map((cur) => [cur, cur]),
) as TranslationKeys;
